var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"article-tradingview"}},[_c('section',{attrs:{"id":"section-tradingview"}},[(_vm.name && _vm.type)?_c(_vm.componentId,{tag:"component",attrs:{"name":_vm.name,"mode":'advanced'}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }